<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.lcCode" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.matCode" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.matName" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="pagination.fcCode">
                    <el-form-item label="批号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.batchNo" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="!pagination.fcCode">
                    <el-form-item label="批号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.batchNo" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="箱号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.boxBarcode" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="pagination.beginTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="pagination.endTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="保质期到期提醒">
              <el-button v-authority="'BACK_MENU7_M6_B2'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="insertOpenRecord">复检记录</el-button>
              <el-button v-authority="'BACK_MENU7_M6_B3'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="reInspection('OK')">合格</el-button>
              <el-button v-authority="'BACK_MENU7_M6_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="reInspection('NOK')">不合格</el-button>
              <el-button v-authority="'BACK_MENU7_M6_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total" @selectionChange="selectAllPrintLists">
                <!-- <el-table-column prop="lcCode" label="库位编号" /> -->
              <el-table-column type="selection" align="center"></el-table-column>
              <el-table-column prop="matCode" label="物料编号" />
                <el-table-column prop="matName" label="物料描述" />
                <el-table-column prop="matQuan" label="物料数量" />
                <el-table-column prop="batchNo" label="批号" />
                <el-table-column prop="boxBarcode" label="箱号" />
                <el-table-column label="通道" align="center" prop="whCode">
                </el-table-column>
                <el-table-column prop="lcCode" label="库位" />
                <!-- <el-table-column prop="palletCode" label="托盘编号" />-->
                <!-- <el-table-column prop="checkFlag" label="是否质检"> 
                    <template slot-scope="scope">
                        <div v-if="scope.row.checkFlag == false">否</div>
                        <div v-if="scope.row.checkFlag == true">是</div>
                    </template>
                </el-table-column> -->
                <el-table-column prop="rkTime" label="生产时间" />
                <el-table-column prop="reInspectionTime" label="复检时间" />
                <el-table-column prop="validityMonth" label="保质时间" />
                <el-table-column prop="expirationTime" label="保质期至">
                </el-table-column>

                <el-table-column prop="day" label="剩余天数">
                    <template slot-scope="scope">
                        <div v-if="scope.row.day < 0" style="color: red; font-weight: bold">
                            超期 {{ scope.row.day * (-1) }} 天
                        </div>
                        <div v-if="scope.row.day <= 30 && scope.row.day >= 0" style="color: red; font-weight: bold">
                            {{ scope.row.day }} 天
                        </div>
                        <div v-if="scope.row.day > 30">{{ scope.row.day }} 天</div>
                    </template>
                </el-table-column>
              <el-table-column prop="" label="操作">
                <template slot-scope="scope">
                  <div class="tabke-el">
                    <el-button class="btn-t-edit" @click="detailDialog(scope.row.boxBarcode)" v-authority="'BACK_MENU7_M6_B1'" >明细</el-button>

                  </div>
                </template>

              </el-table-column>
            </h-table>
        </box>

      <el-dialog title="明细" :visible.sync="detailData.insertShowRecord" class="fromDialog"  :style="$popups.popups(0.8,0.9)"  :close-on-click-modal="false" :show-close="false">
        <h-table :headerCellStyle="detailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.8)" @pageChange="getDataList()" :data="detailData.data" pagination :nowPage.sync="detailData.pageNum" :pageSize.sync="detailData.pageSize" :total.sync="detailData.total">

          <el-table-column label="物料编号" align="center" prop="matCode">
          </el-table-column>
          <el-table-column label="物料描述" align="center" prop="matName">
          </el-table-column>
          <el-table-column label="物料数量" align="center" prop="matQuan">
          </el-table-column>
          <el-table-column label="批次号" align="center" prop="batchNo">
          </el-table-column>
          <el-table-column label="包装箱号" align="center" prop="boxCode">
          </el-table-column>
          <el-table-column label="库位" align="center" prop="lcCode">
          </el-table-column>
          <el-table-column label="通道" align="center" prop="whCode">
          </el-table-column>
          <el-table-column label="复检状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.sqResult == 'OK'">合格</span>
              <span v-if="scope.row.sqResult == 'NOK'">不合格</span>
            </template>
          </el-table-column>
          <el-table-column label="操作人员" align="center" prop="person">
          </el-table-column>
          <el-table-column label="创建时间" align="center" prop="createTime">
          </el-table-column>

        </h-table>
        <br><br>

        <div slot="footer" class="dialog-footer footer-bottom">
          <el-button @click="detailData.insertShowRecord = false" type="info" class="btn-t-info">关 闭</el-button>

        </div>
      </el-dialog>


      <el-dialog title="复检记录" :visible.sync="mainSearcRecord.insertShowRecord" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false">
        <el-form label-position="right" label-width="80px" class="EL-Form">
         <!--
          <el-col :lg="5" :xl="5">
            <el-form-item label="通道编号" class="EL-Form-Item">
              <el-select v-model="mainSearcRecord.query.whCode" placeholder="请选择" clearable="clearable">
                <el-option v-for="item in WhCodeList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName">{{item.whCode}}-{{item.whName}}</el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
          <el-col :lg="5" :xl="5">
            <el-form-item label="物料编号" class="EL-Form-Item">
              <el-input v-model="mainSearcRecord.query.matCode" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="物料批次" class="EL-Form-Item">
              <el-input v-model="mainSearcRecord.query.batchNo" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5" v-if="mainSearcRecord.query.fcCode">
            <el-form-item label="包装箱号" class="EL-Form-Item">
              <el-input v-model="mainSearcRecord.query.boxCode" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="状态" class="EL-Form-Item">
              <el-select   v-model="mainSearcRecord.query.sqResult" clearable="clearable">
                <el-option key="1" value="OK" label="合格"></el-option>
                <el-option key="2" value="NOK" label="不合格"></el-option>
              </el-select>
            </el-form-item>
          </el-col>


          <el-col :lg="5" :xl="5" v-if="!mainSearcRecord.query.fcCode">
            <el-form-item label="包装箱号" class="EL-Form-Item">
              <el-input v-model="mainSearcRecord.query.boxBarcode" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
          <!--
          <el-col :lg="5" :xl="5">
            <el-form-item label="规值" class="EL-Form-Item">
              <el-input v-model="mainSearcRecord.query.matSpecs" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
          -->
          <el-col :lg="5" :xl="5">
            <el-form-item label="操作人" class="EL-Form-Item">
              <el-input v-model="mainSearcRecord.query.person" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="开始日期" class="EL-Form-Item">
              <el-date-picker v-model="mainSearcRecord.query.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="startPickerOptions"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="结束日期" class="EL-Form-Item">
              <el-date-picker v-model="mainSearcRecord.query.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="finishPickerOptions"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :xl="6">
            <el-form-item class="btn-edit-delete EL-Form-Item">
              <el-button class="btn-t-edit" @click="getOtherRecordList()">查询</el-button>
              <el-button class="btn-t-delete" @click="resetClick('mainSearcRecord')">重置</el-button>
              <el-button v-authority="'BACK_MENU7_M6_B3'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="reInspection('OK')">合格</el-button>
              <el-button v-authority="'BACK_MENU7_M6_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="reInspection('NOK')">不合格</el-button>
            </el-form-item>
          </el-col>
        </el-form>

        <h-table :headerCellStyle="mainSearcRecord.headerCellStyle" :style="$popups.harvestRecordStyle(0.60)" @pageChange="getOtherRecordList()" :data="mainSearcRecord.data" pagination :nowPage.sync="mainSearcRecord.pageNum" :pageSize.sync="mainSearcRecord.pageSize" :total.sync="mainSearcRecord.total"  @selectionChange="selectAllPrintLists">
          <el-table-column type="selection" align="center"> </el-table-column>

          <el-table-column label="物料编号" align="center" prop="matCode">
          </el-table-column>
          <el-table-column label="物料描述" align="center" prop="matName">
          </el-table-column>
          <el-table-column label="物料数量" align="center" prop="matQuan">
          </el-table-column>

          <el-table-column label="物料批次" align="center" prop="batchNo">
          </el-table-column>
          <!-- <el-table-column label="入库库区" align="center" prop="whArea">
          </el-table-column> -->

          <el-table-column label="包箱编号" align="center" prop="boxCode">
          </el-table-column>
          <el-table-column label="库位" align="center" prop="lcCode">
          </el-table-column>
          <el-table-column label="通道" align="center" prop="whCode">
          </el-table-column>
          <el-table-column label="复检状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.sqResult == 'OK'">合格</span>
              <span v-if="scope.row.sqResult == 'NOK'">不合格</span>
            </template>
          </el-table-column>
          <el-table-column label="操作时间" align="center" prop="createTime">
          </el-table-column>
          <el-table-column label="操作人" align="center" prop="person">
          </el-table-column>
        </h-table>
        <div slot="footer" class="dialog-footer footer-bottom">
          <el-button size="mini" @click="mainSearcRecord.insertShowRecord = false" type="info">关闭</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "ExpirationReminder",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                detailData: {
                  smCode: "",
                 data: [],
                  pageNum: 1,
                  pageSize: 50,
                  total: 0,
                  insertShowRecord: false,
                  headerCellStyle: () => {
                    return "background-color: #1f6cec";
                  },
                },
              /* 复检记录 */
              mainSearcRecord: {
                query: {
                  fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                  //whCode: localStorage.getItem("whCode") || "", // 通道编号
                  sorType: "20",
                  sorTypeSub: "", //业务类型
                  reasonCode: "",//调整原因
                  matCode: "", //	物料编号
                  batchNo: "", //	批次号
                  boxCode: "", //	箱号
                  matSpecs: "", //	规值
                  matLenValue: "", //	L值
                  person: "", //	操作人
                  date: [],
                  sqResult:"",
                },
                pageNum: 1,
                pageSize: 50,
                total: 0,
                data: [],
                insertShowRecord: false,
                headerCellStyle: () => {
                  return "background-color: #1f6cec";
                },
              },
                form: {},
                //主数据
                mainData: [],
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    matCode: "",
                    lcCode: "",
                    batchNo: "",
                    matName: "",
                    quanbu: "0",
                    fcCode: localStorage.getItem("fcCode") || "",
                    boxBarcode: "",
                    beginTime:"",
                    endTime:"",
                },
                taskTab: "0",
                factoryList: [],
                selectAllPrintList:[],

                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    },1000)
                },
                deep: true,
            },
          "mainSearcRecord.query": {
            handler() {
              clearTimeout(this.isSetTimeout);
              this.isSetTimeout = setTimeout(() => {
                this.getOtherRecordList();
              }, 1000);
            },
            deep: true,
          },
        },
        computed: {
            pickerOptions() {
                let _this = this;
                return {
                    disabledDate(time) {
                        if (_this.pagination.beginTime) {
                            return time.getTime() < new Date(_this.pagination.beginTime);
                        }
                    },
                };
            },
            pickerOptions0() {
                let _this = this;
                return {
                    disabledDate(time) {
                        if (_this.pagination.endTime) {
                            return time.getTime() > new Date(_this.pagination.endTime);
                        }
                    },
                };
            },
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy);
                window.lazy = window.setTimeout(() => {
                    this.getAuxiMaterialData();
                }, 1000);
            },
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/inventory/getInventoryExpirationReminder",
                        method: "GET",
                        params: {
                            pageNum: this.pagination.pageNum,
                            pageSize: this.pagination.pageSize,
                            matCode: this.pagination.matCode,
                            lcCode: this.pagination.lcCode,
                            batchNo: this.pagination.batchNo,
                            matName: this.pagination.matName,
                            quanbu: this.pagination.quanbu,
                            fcCode: this.pagination.fcCode,
                            boxBarcode: this.pagination.boxBarcode,
                            beginTime: this.pagination.beginTime || null,
                            endTime: this.pagination.endTime || null,
                        },
                    })
                    .then((resp) => {
                        this.loading--;
                        if (resp.status == 100) {
                            if(resp.data.total != 0){
                                resp.data.list.forEach((ele) => {
                                    ele.validityMonth = ele.validityMonth * 30 + "天";
                                    ele.matExpireTime = ele.matCreateTime;
                                    var newMonth = ele.matExpireTime.split(" ")[0].split("-")[1] * 1;
                                    var newYear = ele.matExpireTime.split(" ")[0].split("-")[0] * 1;
                                    if (newMonth + ele.validityMonth * 1 > 12) {
                                        console.log(newMonth + ele.validityMonth * 1)
                                        if ((newMonth + ele.validityMonth * 1) % 12 == 0) {
                                            var arr = [];
                                            var str = Math.floor((newMonth + ele.validityMonth * 1) / 12) - 1; // 年
                                            var Year = newYear + str + "";
                                            var Month = (newMonth + ele.validityMonth * 1) - 12 * str + "";
                                            arr.push(Year);
                                            arr.push(Month);
                                            arr.push(ele.matExpireTime.split(" ")[0].split("-")[2]);
                                            arr.join("-")
                                            ele.matExpireTime = arr.join("-") + " " + ele.matExpireTime.split(" ")[1];
                                        } else {
                                            var arr = [];
                                            var str = Math.floor((newMonth + ele.validityMonth * 1) / 12);
                                            var Year = newYear + str + "";
                                            var Month = (newMonth + ele.validityMonth * 1) - 12 * str + "";
                                            arr.push(Year);
                                            arr.push(Month);
                                            arr.push(ele.matExpireTime.split(" ")[0].split("-")[2]);
                                            arr.join("-")
                                            ele.matExpireTime = arr.join("-") + " " + ele.matExpireTime.split(" ")[1];
                                        }
                                    }
                                })    
                            }
                            
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.loading--;
                    });
            },
          /**
           * 全选
           */
          selectAllPrintLists(val) {
            this.selectAllPrintList = val;
          },
          /* 复检记录弹出框 */
          insertOpenRecord() {
            this.mainSearcRecord.insertShowRecord = true;
            this.getOtherRecordList();
          },
          /* 查询交易调整记录数据 */
          getOtherRecordList() {
            this.$http
                .request({
                  url: "/api/inventory/getReInspection",
                  method: "GET",
                  params: {
                    pageNum: this.mainSearcRecord.pageNum, // 页号
                    pageSize: this.mainSearcRecord.pageSize, // 页大小
                    fcCode: this.mainSearcRecord.query.fcCode || null, // 工厂编号
                    matCode: this.mainSearcRecord.query.matCode || null, //物料编号
                    batchNo: this.mainSearcRecord.query.batchNo || null, //批次号
                    boxCode: this.mainSearcRecord.query.boxCode || null, //箱号
                    matSpecs: this.mainSearcRecord.query.matSpecs || null, //规值
                    person: this.mainSearcRecord.query.person || null, //操作人
                    beginTime: this.mainSearcRecord.query.date ?
                        this.mainSearcRecord.query.date[0] : null,
                    endTime: this.mainSearcRecord.query.date ?
                        this.mainSearcRecord.query.date[1] : null,
                    sqResult:this.mainSearcRecord.query.sqResult || null,
                  },
                })
                .then((res) => {
                  if (res.status == 100) {
                    this.mainSearcRecord.data = res.data.list;
                    this.mainSearcRecord.total = res.data.total;
                  } else {
                    this.$message.error("错误");
                  }
                })
                .catch((error) => {
                  this.$message.error("错误");
                });
          },
          /* 明细 */
          detailDialog(boxCode) {
            this.detailData.insertShowRecord = true;
            this.detailData.smCode = boxCode;
            this.getDataList(boxCode);
          },
          getDataList(boxCode) {
            this.$http
                .request({
                  url: "/api/inventory/getReInspection",
                  method: "GET",
                  params: {
                    pageNum: this.detailData.nowPage,
                    pageSize: this.detailData.pageSize,
                    smCode: this.detailData.smCode,
                    boxCode: boxCode || "",
                  },
                })
                .then((resp) => {
                  if (resp.status == 100) {
                    this.detailData.data = resp.data.list || [];
                    this.detailData.total = resp.data.total;
                  }
                })
                .catch((error) => {
                  this.$message({
                    message: "操作失败",
                    type: "warning",
                  });
                });
          },
            //获取工厂数据
            getFactoryAll() {
                this.$http
                    .request({
                        url: "/api/factory/getFactoryAll",
                        method: "GET",
                        params: {},
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.factoryList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //重置
            resetData() {
                this.pagination = {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    matCode: "",
                    lcCode: "",
                    batchNo: "",
                    matName: "",
                    quanbu: this.pagination.quanbu,
                    fcCode: localStorage.getItem("fcCode") || "",
                    boxBarcode: "",
                    beginTime: "",
                    endTime:"",
                };
                this.getAuxiMaterialData();
            },

          reInspection(val){

            if(this.selectAllPrintList.length==0){
              this.$message({
                message: "请选择库存记录！",
                type: "warning",
              });
              return;
            }
            this.selectAllPrintList.forEach(function(c) {
              if (c.boxBarcode == undefined || c.boxBarcode == '') {
                c["boxBarcode"] = c.boxCode;
              }
            });
            this.$http
                .request({
                  url: "/api/inventory/whInventoryReInspection",
                  method: "POST",
                  params: {
                    person: localStorage.getItem("user") || "",
                    result: val,
                  },
                  data: this.selectAllPrintList,
                })
                .then((resp) => {
                  resp.status == 100 ?
                      this.$notify({
                        title: "成功",
                        message: "操作成功！",
                        type: "success",
                      }) :
                      this.$notify.error({
                        message: "操作失败",
                      });
                  this.getAuxiMaterialData();
                  this.getOtherRecordList();
                });
          },
            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    matCode: this.pagination.matCode,
                    lcCode: this.pagination.lcCode,
                    batchNo: this.pagination.batchNo,
                    matName: this.pagination.matName,
                    quanbu: this.pagination.quanbu,
                    fcCode: this.pagination.fcCode,
                    boxBarcode: this.pagination.boxBarcode,
                    beginTime: this.pagination.beginTime || null,
                    endTime: this.pagination.endTime || null,
                    pageNum: 1,
                    pageSize: 999999,
                };

                this.$http
                    .request({
                        url: "/api/inventory/getInventoryExpirationReminder",
                        method: "GET",
                        params: paramsObj,
                    })
                    .then((resp) => {
                        resp.status == 100 ?
                            this.downLoad(resp.data.list || []) :
                            this.$notify.error({
                                message: "查询失败",
                            });
                    });
            },
            downLoad(list) {
                import("@/libs/Export2Excel").then((excel) => {
                    list.forEach(function(c) {
                        if (c.checkFlag == true) {
                            c["checkFlag"] = "是";
                        } else if (c.checkFlag == false) {
                            c["checkFlag"] = "否";
                        }
                        
                        c.matExpireTime = c.matCreateTime;
                        var newMonth = c.matExpireTime.split(" ")[0].split("-")[1] * 1;
                        var newYear = c.matExpireTime.split(" ")[0].split("-")[0] * 1;

                        if (newMonth + c.validityMonth * 1 > 12) {
                            if ((newMonth + c.validityMonth * 1) % 12 == 0) {
                                var arr = [];
                                var str = Math.floor((newMonth + c.validityMonth * 1) / 12) - 1; // 年
                                var Year = newYear + str + "";
                                var Month = (newMonth + c.validityMonth * 1) - 12 * str + "";
                                arr.push(Year);
                                arr.push(Month);
                                arr.push(c.matExpireTime.split(" ")[0].split("-")[2]);
                                arr.join("-")
                                c.matExpireTime = arr.join("-") + " " + c.matExpireTime.split(" ")[1];
                            } else {
                                var arr = [];
                                var str = Math.floor((newMonth + c.validityMonth * 1) / 12);
                                var Year = newYear + str + "";
                                var Month = (newMonth + c.validityMonth * 1) - 12 * str + "";
                                arr.push(Year);
                                arr.push(Month);
                                arr.push(c.matExpireTime.split(" ")[0].split("-")[2]);
                                arr.join("-")
                                c.matExpireTime = arr.join("-") + " " + c.matExpireTime.split(" ")[1];
                            }
                        }
                        if (c.day < 0) {
                          c["day"] = '超期' + c.day * (-1) + '天';
                        } else {
                          c["day"] = c.day + '天';
                        } 
                        c['validityMonth'] = c.validityMonth * 30 + '天';

                    });
                    const tHeader = [
                        "物料编号",
                        "物料描述",
                        "物料数量",
                        "批号",
                        "箱号",
                        "通道",
                        "库位",
                        "生产时间",
                        "复检时间",
                        "保质时间",
                        "保质期至",
                        "剩余天数"
                    ];
                    const filterVal = [
                        "matCode",
                        "matName",
                        "matQuan",
                        "batchNo",
                        "boxBarcode",
                        "whCode",
                        "lcCode",
                        "rkTime",
                        "reInspectionTime",
                        "validityMonth",
                        "expirationTime",
                        "day"
                    ];
                    const data = this.formatJson(filterVal, list);
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: "保质期报表数据",
                    });
                    this.logContent = "导出";
                    this.logRemarks = "wh_inventory：导出保质期报表数据";
                    this.systemLog();
                    this.downloadLoading = false;
                });
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map((v) => filterVal.map((j) => v[j]));
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "保质期到期提醒",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            this.getFactoryAll();
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
        },
    };
</script>